import classNames from 'classnames';
import { useFormikContext, getIn } from 'formik';

import FormError from './common/FormError';

const RadioGroup = (props) => {
  const {
    children,
    className,
    label,
    labelSROnly = false,
    name,
    required,
    dataTestId = 'radio-group'
  } = props;

  const formikContext = useFormikContext();

  const { errors, touched } = formikContext;

  const error = getIn(errors, name);
  const touch = getIn(touched, name);

  const errorId = `c7-${name}-error`;

  let ariaDescribedBy;
  if (touch && error) {
    ariaDescribedBy = errorId;
  }

  return (
    <div
      className={classNames('c7-form__field', className)}
      data-testId={dataTestId}
    >
      <fieldset aria-describedby={ariaDescribedBy}>
        <legend
          className={classNames(
            required && 'c7-required',
            labelSROnly && 'c7-sr-only'
          )}
        >
          {label}
        </legend>
        {children}
      </fieldset>
      <FormError touch={touch} error={error} id={errorId} label={label} />
    </div>
  );
};

export default RadioGroup;
